module.exports = __webpack_public_path__ + "img/translink.b74f2ba6.png";